import React from 'react'


const SubmitButtonRaw = ({
    text,
    disabled,
    className="button button-primary",
    label
}) => (
    <button 
        className={className}
        aria-label={label}
        type="submit" 
        disabled={disabled}
        aria-disabled={disabled}
    >
        {text}
    </button>
)

export default SubmitButtonRaw